export default __webpack_public_path__ + "static/media/Skup Pula (17).8daf33db.JPG";